module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQDesc1: 'Use our ',
        shadeFinder: 'Shade Finder',
        colorIQDesc2: ' to discover more matches based on your current foundation, or head to a Sephora store and ask for a Color IQ skin tone scan.',
        captured: 'Captured ',
        viewAll: 'View All'
    };
    return resources[label];
};
